import type { AuthStep } from "@/features/auth/types/auth-flow.type";

/**
 * Form ids let a host render the step's CTA outside the form — the mobile
 * design pins it to a bottom bar.
 */
export const AUTH_FORM_IDS = {
  password: "auth-password-form",
  "create-password": "auth-create-password-form",
  "verify-code": "auth-verify-code-form",
  "reset-code": "auth-reset-code-form",
  "reset-password": "auth-reset-password-form",
} as const;

/**
 * Steps whose CTA moves to a bottom bar on mobile, with the label to show
 * there. The e-mail step keeps its button inline.
 */
export const AUTH_FOOTER_STEPS = {
  password: { formId: AUTH_FORM_IDS.password, labelKey: "password.submit" },
  "create-password": {
    formId: AUTH_FORM_IDS["create-password"],
    labelKey: "createPassword.submit",
  },
  "verify-code": {
    formId: AUTH_FORM_IDS["verify-code"],
    labelKey: "verifyCode.submit",
  },
  "reset-code": {
    formId: AUTH_FORM_IDS["reset-code"],
    labelKey: "verifyCode.submit",
  },
  "reset-password": {
    formId: AUTH_FORM_IDS["reset-password"],
    labelKey: "resetPassword.submit",
  },
} as const satisfies Partial<
  Record<AuthStep, { formId: string; labelKey: string }>
>;

export type AuthFooterStep = keyof typeof AUTH_FOOTER_STEPS;

export const isAuthFooterStep = (step: AuthStep): step is AuthFooterStep =>
  step in AUTH_FOOTER_STEPS;

/** Header copy per step, shared by the dialog and the mobile page header. */
export const AUTH_TITLE_KEYS = {
  email: "email.title",
  password: "password.title",
  "linked-account": "password.title",
  "create-password": "createPassword.dialogTitle",
  "verify-code": "createPassword.dialogTitle",
  "reset-code": "resetPassword.dialogTitle",
  "reset-password": "resetPassword.dialogTitle",
} as const satisfies Record<AuthStep, string>;
